/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpLeftIcon32Regular = forwardRef('ArrowDRadiusUpLeftIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M11.293 4.293a1 1 0 1 1 1.414 1.414L5.414 13H16c7.18 0 13 5.82 13 13v1a1 1 0 1 1-2 0v-1c0-6.075-4.925-11-11-11H5.415l7.292 7.293a1 1 0 1 1-1.414 1.414L3.955 16.37a3.35 3.35 0 0 1 0-4.738l7.338-7.338Z" })));
});
